import { howItWorksSteps } from '@/mocks/howItWorks';
import StepCard from './StepCard';

export default function ProcessSteps() {
  return (
    <section id="process" className="w-full bg-cream-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="space-y-16 md:space-y-24">
            {howItWorksSteps.map((step, index) => (
              <StepCard key={step.id} step={step} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}